import { EventMasterActionConst } from "../Constants/EventMasterConstants";

const initialState = {
  loader: false,
  events: [],
  eventsError: null,
  detail: null,
  detailError: null,
  collaboration: null,
  collaborationError: null,
  flaggedEvents: [],
  flaggedEventsError: null,
  actionSuccess: null,
  actionError: null,
};

const eventMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    // ─── List ────────────────────────────────────────────────────────────────
    case EventMasterActionConst.FETCH_ALL_EVENTS_REQUEST:
      return { ...state, loader: true, eventsError: null };

    case EventMasterActionConst.FETCH_ALL_EVENTS_SUCC:
      return {
        ...state,
        loader: false,
        events: action.result.data || [],
        eventsError: null,
      };

    case EventMasterActionConst.FETCH_ALL_EVENTS_FAIL:
      return { ...state, loader: false, eventsError: action.result, events: [] };

    // ─── Detail ──────────────────────────────────────────────────────────────
    case EventMasterActionConst.FETCH_EVENT_DETAIL_REQUEST:
      return {
        ...state,
        loader: true,
        detail: null,
        detailError: null,
        collaboration: null,
        actionSuccess: null,
        actionError: null,
      };

    case EventMasterActionConst.FETCH_EVENT_DETAIL_SUCC:
      return { ...state, loader: false, detail: action.result.data, detailError: null };

    case EventMasterActionConst.FETCH_EVENT_DETAIL_FAIL:
      return { ...state, loader: false, detailError: action.result, detail: null };

    // ─── Collaboration ───────────────────────────────────────────────────────
    case EventMasterActionConst.FETCH_EVENT_COLLABORATION_REQUEST:
      return { ...state, collaboration: null, collaborationError: null };

    case EventMasterActionConst.FETCH_EVENT_COLLABORATION_SUCC:
      return { ...state, collaboration: action.result.data, collaborationError: null };

    case EventMasterActionConst.FETCH_EVENT_COLLABORATION_FAIL:
      return { ...state, collaborationError: action.result };

    // ─── Update ──────────────────────────────────────────────────────────────
    case EventMasterActionConst.UPDATE_EVENT_REQUEST:
      return { ...state, loader: true, actionSuccess: null, actionError: null };

    case EventMasterActionConst.UPDATE_EVENT_SUCC:
      return {
        ...state,
        loader: false,
        actionSuccess: action.result,
        detail: action.result.data,
        events: state.events.map((e) =>
          e.id === action.id ? { ...e, ...action.result.data } : e
        ),
      };

    case EventMasterActionConst.UPDATE_EVENT_FAIL:
      return { ...state, loader: false, actionError: action.result, actionSuccess: null };

    // ─── Publish ─────────────────────────────────────────────────────────────
    case EventMasterActionConst.PUBLISH_EVENT_REQUEST:
      return { ...state, loader: true, actionSuccess: null, actionError: null };

    case EventMasterActionConst.PUBLISH_EVENT_SUCC:
      return {
        ...state,
        loader: false,
        actionSuccess: action.result,
        events: state.events.map((e) =>
          e.id === action.id ? { ...e, isDraft: false, status: 'Active' } : e
        ),
      };

    case EventMasterActionConst.PUBLISH_EVENT_FAIL:
      return { ...state, loader: false, actionError: action.result, actionSuccess: null };

    // ─── Remove ──────────────────────────────────────────────────────────────
    case EventMasterActionConst.REMOVE_EVENT_REQUEST:
      return { ...state, loader: true, actionSuccess: null, actionError: null };

    case EventMasterActionConst.REMOVE_EVENT_SUCC:
      return {
        ...state,
        loader: false,
        actionSuccess: action.result,
        events: state.events.filter((e) => e.id !== action.id),
      };

    case EventMasterActionConst.REMOVE_EVENT_FAIL:
      return { ...state, loader: false, actionError: action.result, actionSuccess: null };

    // ─── Flagged Events ──────────────────────────────────────────────────────
    case EventMasterActionConst.FETCH_FLAGGED_EVENTS_REQUEST:
      return { ...state, flaggedEventsError: null };

    case EventMasterActionConst.FETCH_FLAGGED_EVENTS_SUCC:
      return { ...state, flaggedEvents: action.result.data || [], flaggedEventsError: null };

    case EventMasterActionConst.FETCH_FLAGGED_EVENTS_FAIL:
      return { ...state, flaggedEventsError: action.result };

    // ─── Flag Decision ───────────────────────────────────────────────────────
    case EventMasterActionConst.FLAG_DECISION_REQUEST:
      return { ...state, actionSuccess: null, actionError: null };

    case EventMasterActionConst.FLAG_DECISION_SUCC:
      return {
        ...state,
        actionSuccess: action.result,
        flaggedEvents: state.flaggedEvents.map((f) =>
          f.id === action.id ? { ...f, decision: action.decision } : f
        ),
      };

    case EventMasterActionConst.FLAG_DECISION_FAIL:
      return { ...state, actionError: action.result };

    // ─── Clear ───────────────────────────────────────────────────────────────
    case EventMasterActionConst.CLEAR_EVENT_ACTION_STATE:
      return { ...state, actionSuccess: null, actionError: null };

    default:
      return state;
  }
};

export default eventMasterReducer;
